import { render, staticRenderFns } from "./LearningMaterial.vue?vue&type=template&id=e79d78be&scoped=true"
import script from "./LearningMaterial.vue?vue&type=script&lang=ts"
export * from "./LearningMaterial.vue?vue&type=script&lang=ts"
import style0 from "./LearningMaterial.vue?vue&type=style&index=0&id=e79d78be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e79d78be",
  null
  
)

export default component.exports